const counter = {};
export default function uid(prefix = '') {
    if (typeof counter[prefix] === 'undefined') {
        counter[prefix] = 0;
    }
    counter[prefix] += 1;
    return `${prefix || 'ndsElem'}_${counter[prefix]}`;
}
//# sourceMappingURL=uid.js.map